export default {"src":"/_next/static/media/logo-mastercard.bbf29af2.svg","height":32,"width":42,"blurWidth":0,"blurHeight":0};